// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { NodeHttpsClient as DefaultHttpsClient } from "./nodeHttpsClient";
